import React, { useState } from "react";
import { FaTruck, FaHandHolding } from "react-icons/fa";
import { BsBoxSeamFill } from "react-icons/bs";
import "./styles.scss";

export default function CustomMapMarkerCircleIcon({ icon, color }) {
  const [isHovered, setIsHovered] = useState(false);

  const getIconComponent = () => {
    if ((icon === "pack" || icon === "ownCollect") && !isHovered) return null;
    switch (icon) {
      case "truck":
        return <FaTruck className="custom-icon icon-truck" />;
      case "pack":
        return <BsBoxSeamFill className="custom-icon icon-pack" />;
      case "ownCollect":
        return <FaHandHolding className="custom-icon icon-ownCollect" />;
      default:
        return null;
    }
  };

  const isTruck = icon === "truck";
  const markerClass = isTruck
    ? "truck-marker"
    : isHovered
      ? "is-large"
      : "is-small";

  return (
    <div
      className={`custom-marker-circle ${markerClass}`}
      style={{
        backgroundColor: color,
        zIndex: isHovered ? 9999999999 : 1,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {getIconComponent()}
    </div>
  );
}
